import { MenuProvider } from '../../../../../services/exports/Constants';

export default {
  form: {
    provider: {
      label: 'Menu provider',
      options: {
        [null]: 'Select menu provider',
        [MenuProvider.Lieferando]: 'Lieferando',
        [MenuProvider.Wolt]: 'Wolt',
        [MenuProvider.Deliveroo]: 'Deliveroo',
        [MenuProvider.UberEats]: 'Uber Eats',
        [MenuProvider.GloriaFood]: 'GloriaFood',
        [MenuProvider.Foodamigos]: 'Other FoodAmigos restaurant',
        [MenuProvider.DoorDash]: 'DoorDash',
        [MenuProvider.Tabless]: 'Tabless (POS)',
        [MenuProvider.Thuisbezorgd]: 'Thuisbezorgd',
        [MenuProvider.TakeawayCom]: 'Takeaway.com',
        [MenuProvider.PysznePl]: 'Pyszne.pl',
        [MenuProvider.BistroSk]: 'Bistro.sk',
        [MenuProvider.JustEat]: 'Just Eat',
      },
    },
    provider_id: {
      [MenuProvider.Lieferando]: {
        label: 'Lieferando URL',
        placeholder: 'URL of the restaurant in Lieferando',
      },
      [MenuProvider.Wolt]: {
        label: 'Wolt URL',
        placeholder: 'URL of the restaurant in Wolt',
      },
      [MenuProvider.Deliveroo]: {
        label: 'Deliveroo menu link',
        placeholder: 'https://deliveroo…/menu/city/area/restaurant',
        help: 'Open your restaurant on Deliveroo and copy the link from the address bar.',
        error:
          'Enter the link to a Deliveroo restaurant menu page. It looks like https://deliveroo.co.uk/menu/city/area/restaurant-name.',
      },
      [MenuProvider.UberEats]: {
        label: 'Uber Eats URL',
        placeholder: 'URL of the restaurant in Uber Eats',
      },
      [MenuProvider.GloriaFood]: {
        label: 'GloriaFood link',
        placeholder: 'https://www.foodbooking.com/ordering/restaurant/menu?restaurant_uid=…',
        help: {
          ordering_page: {
            title: 'If you use the GloriaFood ordering page:',
            description: 'Enter your foodbooking.com ordering URL.',
            example: 'https://www.foodbooking.com/ordering/restaurant/menu?restaurant_uid=…',
          },
          embedded_widget: {
            title: 'If GloriaFood is embedded on your own website:',
            description: 'Enter the URL of the page on your site where the ordering widget appears.',
            example: 'https://yourrestaurant.com/order',
          },
        },
        error: 'Enter a valid link starting with https://.',
        back_office_error:
          "That is a GloriaFood back-office link, not the page your customers order from. Open your restaurant's ordering page and paste that link instead.",
        wrong_platform_error:
          "This doesn't look like a GloriaFood link. If you use the GloriaFood hosted page, enter your foodbooking.com ordering URL. If GloriaFood is embedded on your own website, enter the page URL where your ordering widget appears.",
      },
      [MenuProvider.Thuisbezorgd]: {
        label: 'Thuisbezorgd URL',
        placeholder: 'URL of the restaurant in Thuisbezorgd',
      },
      [MenuProvider.TakeawayCom]: {
        label: 'Takeaway.com URL',
        placeholder: 'URL of the restaurant in Takeaway.com',
      },
      [MenuProvider.PysznePl]: {
        label: 'Pyszne.pl URL',
        placeholder: 'URL of the restaurant in Pyszne.pl',
      },
      [MenuProvider.BistroSk]: {
        label: 'Bistro.sk URL',
        placeholder: 'URL of the restaurant in Bistro.sk',
      },
      [MenuProvider.JustEat]: {
        label: 'Just Eat URL',
        placeholder: 'URL of the restaurant in Just Eat',
      },
      [MenuProvider.DoorDash]: {
        label: 'DoorDash store link',
        placeholder: 'https://www.doordash.com/store/…',
        help: 'Open your restaurant on doordash.com and copy the link from the address bar.',
        error: 'Enter the link to a DoorDash store page. It starts with https://www.doordash.com/store/.',
        store_number_error:
          'That link has only the store number. Open the restaurant on doordash.com and copy the link with its name, like https://www.doordash.com/store/restaurant-name-123456/.',
      },
      [MenuProvider.Foodamigos]: {
        label: 'Restaurant to copy menu from',
        placeholder: 'Select restaurant to copy menu from',
      },
    },
  },
};
